import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchRecentBlogs } from "redux/features/blog/blogSlice";

const LatestBlogPost = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  let blogState = useAppSelector((state) => state.featureBlog.blogs);

  useEffect(() => {
    dispatch(fetchRecentBlogs());
  }, []);

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
    };
    return date.toLocaleDateString("fr-FR", options);
  };

  return (
    <div className="py-10 bg-gray-100 dark:bg-neutral-800">
      <div className="container flex flex-col gap-8 px-4 mx-auto md:flex-row">
        <div className="flex flex-col justify-between md:w-1/3">
          <div>
            <h1 className="mb-4 text-4xl font-bold text-gray-800 dark:text-white">
              Nos conseils pour organiser votre événement
            </h1>
          </div>
          <div className="flex items-end">
            <button
              className="w-1/2 px-6 py-3 font-semibold text-white transition rounded-full bg-eventToBee hover:bg-eventToBee/80"
              onClick={() => navigate("/blogs")}
            >
              Plus d’idées & d’inspirations
            </button>
          </div>
        </div>

        <div className="flex flex-col gap-6 md:w-2/3 md:flex-row">
          {blogState?.map((item, index) => (
            <div
              className="overflow-hidden bg-white dark:bg-neutral-800 rounded-lg shadow-md flex-1 md:max-w-[400px]  "
              key={item.id || index}
            >
              <div className="relative h-48">
                <img
                  src={process.env.REACT_APP_CLOUD_FRONT + item.blog_url}
                  alt="Blog 1"
                  className="object-cover w-full h-full"
                />
                <div className="absolute px-3 py-1 text-white rounded bg-eventToBee/80 top-4 left-4">
                  {formatDate(item.createdAt)}
                </div>
              </div>
              <div className="flex flex-col p-4 min-h-[180px]">
                <div className="flex items-center mb-2 text-sm text-gray-500">
                  <span>
                    <span>
                      <i className="las la-user-alt"></i>
                    </span>
                    {item.publisher}
                  </span>
                </div>
                <h2 className="overflow-hidden font-semibold text-gray-800 dark:text-white">{item.title}</h2>
                <div className="flex-1"></div>
                <a
                  href={`/blog-single/${item.id}`}
                  className="self-start font-semibold text-eventToBee hover:underline"
                >
                  Consulter
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LatestBlogPost;
